import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persister } from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";

// Remove the old persist key so stale uploadedImage/uploadedVideo data
// (stored under the previous 'newwww-account' key) is cleared on first load.
const OLD_PERSIST_KEY = 'persist:account';
if (localStorage.getItem(OLD_PERSIST_KEY) !== null) {
  localStorage.removeItem(OLD_PERSIST_KEY);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
